import React from 'react';
import Main from '../../organisms/Main/Main';

function Kitchen() {
	return <Main title='Kuchnia' category='kitchen' status='false' />;
}

export default Kitchen;
